<tyt-post
  *ngFor="let post of posts"
  [post]="post"
  [compact]="true"
  [showParent]="false"
  [showAsTopLevel]="true"
  quickAction="like"
  ></tyt-post>
